import { mapKeys, pick } from 'lodash-es';
import { addDays, startOfDay } from 'date-fns/esm';
import { convertToISO8601 } from '../../../../constants';
import { getMovingCenterDataState } from '../';
import { actions, selectors } from '../../../../state';
import template from './moving-center-form.html';
import './moving-center-form.global.css';

class MovingCenterFormController {
  constructor(MovingCenterActions, updStore, $state, $timeout, $element) {
    'ngInject';
    Object.assign(this, {
      MovingCenterActions,
      updStore,
      $timeout,
      $element,
    });
  }

  $onInit() {
    const { connect, getState } = this.updStore;
    const { info, move } = getFormFieldsFromState(getState());

    this.formInfo = info;
    this.move = move;
    this.minDate = convertToISO8601(addDays(startOfDay(new Date()), 1));

    this.disconnect = connect(mapStateToThis)(this);
  }

  $postLink() {
    this.$element[0]
      .querySelector('#move_date')
      .addEventListener('input', e =>
        this.handleMoveDateChange(e.target.value)
      );
  }

  $onDestroy() {
    this.disconnect();
  }

  handleAddressChange(prefix, address) {
    this.formInfo = {
      ...this.formInfo,
      ...formatAddressFields(address, prefix),
    };
  }

  handleMoveDateChange(move_date) {
    this.formInfo = {
      ...this.formInfo,
      move_date,
    };
  }

  handleMoveKindChange(e) {
    const kind = e.target.value;
    this.formInfo = {
      ...this.formInfo,
      kind,
    };
  }

  handleHomeSizeChange(e) {
    const home_size = e.target.value;
    this.formInfo = {
      ...this.formInfo,
      home_size,
    };
  }

  handleHomeTypeChange(e) {
    const home_type = e.target.value;
    this.formInfo = {
      ...this.formInfo,
      home_type,
    };
  }

  submit(formData) {
    this.submitting = true;
    const { dispatch, getState } = this.updStore;

    const data = Object.assign({}, formData, {
      updater_move_id: this.move.id,
      first_name: this.firstName,
      last_name: this.lastName,
      email: this.email,
    });

    data.flexible_move_date = data.flexible_move_date ? 1 : 0;

    const success = () => {
      const goTo = getMovingCenterDataState(
        selectors.movingCenter.isPremiumKind(this.move.id, getState())
      );
      this.$timeout(
        () => dispatch(actions.router.stateGo(goTo)),
        // Artificial delay per David's request. "Make it look like we're crunching numbers."
        2000
      );
    };

    const error = () => {
      dispatch(
        actions.message.error('There was an error submitting the form.')
      );
    };

    dispatch(this.MovingCenterActions.submit(data))
      .then(success, error)
      .finally(() => (this.submitting = false));
  }
}

export const MovingCenterFormComponent = {
  controller: MovingCenterFormController,
  template,
};

function mapStateToThis(state) {
  const user = selectors.current.user(state);

  return {
    firstName: user.firstName(state),
    lastName: user.lastName(state),
    email: user.email(state),
  };
}

function formatAddressFields(address, prefix) {
  return mapKeys(
    pick(address, ['street', 'apt', 'city', 'state', 'zip']),
    (value, key) => `${prefix}_${key}`
  );
}

function getFormFieldsFromState(state) {
  const move = selectors.current.move(state);
  const user = selectors.current.user(state);

  return {
    info: {
      move_date: move.date(state),
      phone: user.cellPhone(state) || user.homePhone(state),
    },
    move: {
      id: move.id(state),
      date: move.date(state),
      from_address: move.fromAddress(state),
      to_address: move.toAddress(state),
    },
  };
}
